import { PropsWithChildren } from "react"
import { PearlHeader } from "../PearlHeader"
import { PearlHeaderProps } from "../PearlHeader/types"

export const PearlSideBox = ({
  title,
  subtitle,
  avatarUrl,
  children,
  ...rest
}: PropsWithChildren<PearlHeaderProps>) => {
  return (
    <div
      className="sticky top-4 hidden h-fit w-full max-w-md rounded-lg border-2 border-gray-200 bg-white p-4 text-black md:block"
      {...rest}
    >
      <PearlHeader title={title} subtitle={subtitle} avatarUrl={avatarUrl} />
      <div className="mt-8">{children}</div>
    </div>
  )
}
